module.exports = __webpack_public_path__ + "static/media/prev-arrow-white.b6e7ab2a.svg";